import z from 'zod';
import {questionDbSchema} from '../../question/questionDbSchema';

export const sessionQuestionDbSchema = questionDbSchema.extend({
  id: z.string(),
  /** The answer selected by the user. undefined means not answered yet. */
  selectedAnswer: z.string().optional(),
  /** Whether the answer was correct. undefined means not answered yet. */
  isCorrect: z.boolean().optional(),
});

export type SessionQuestionDb = z.infer<typeof sessionQuestionDbSchema>;
